module.exports = __webpack_public_path__ + "2f709fe44a1b3a3d0077d42456c591b0.svg";